module.exports = __webpack_public_path__ + "media/images/checkmark-lg-56ec5668ede7773308c10a84e1d5abce.svg";